import React from "react";
import UploadXlsxFile from "../../../views/settings/uploadXlsxFile";
const UploadFile = ({ processName, title, ...rest }) => (
  <UploadXlsxFile processName={processName} title={title} {...rest} />
);

export default UploadFile;
